<template>
  <div class=" bg-green">
    <div
      class=" max-w-xl lg:max-w-4xl mx-auto  divide-y divide-eggshell divide px-6 py-6 lg:flex lg:divide-none lg:space-x-3 text-center"
    >
      <!-- <a class="py-10 block flex-1" href="https://getnude.com" target="_blank"> -->
      <!-- <img class="w-full h-auto block" src="@/assets/website.png" /> -->

      <!-- <h3 class="text-eggshell font-header text-2xl pt-4">
          Visit our website
        </h3> -->
      <div class="max-w-[550px] mx-auto">
        <p class="text-eggshell text-base py-1">
          You've got the chance to win one of these prizes to boost your
          deposit:
        </p>

        <p class="text-eggshell text-base py-1 font-bold">
          1 x £4,000 prize<br />
          2 x £2,000 prizes<br />
          4 x £500 prizes
        </p>

        <p class="text-eggshell text-base py-1">
          And to spice things up, the winner of the big £4,000 prize will be
          chosen from the team with the most overall entries... so, will it be
          the iPhone gang or the Android massive? It’s in your hands!
        </p>

        <div
          class="flex  items-center justify-center text-center w-full mt-6 space-x-6 max-w-[340px] mx-auto"
          :class="{ 'opacity-0': loading }"
        >
          <span
            class="flex-1 text-center text-3xl"
            :class="{ 'opacity-0': counters.iPhone >= counters.android }"
          >
            👑
          </span>
          <span
            class="flex-1 text-center text-3xl"
            :class="{ 'opacity-0': counters.iPhone <= counters.android }"
          >
            👑
          </span>
        </div>

        <div class="mx-auto block max-w-[330px] my-4">
          <div class="relative">
            <img
              src="@/assets/voting-bars.png"
              class="mx-auto max-w-[275px] rounded-br-md"
            />
            <div
              class="flex inset-0 top-auto absolute items-center justify-center text-center w-full space-x-5"
            >
              <span class="flex-1 font-header text-eggshell text-3xl">{{
                counters["android"]
              }}</span>
              <span class="flex-1 font-header text-eggshell text-3xl">{{
                counters["iPhone"]
              }}</span>
            </div>
          </div>
        </div>
        <div
          class="flex  items-center justify-center text-center w-full mt-6 space-x-6 max-w-[340px] mx-auto"
          v-if="!loading"
        >
          <button
            :disabled="disableButtons"
            v-on:click="voteFor('android')"
            class="disabled:pointer-events-none disabled:opacity-50 flex-1 w-[155px] text-eggshell text-base border-2 rounded-full p-3 py-2.5 text-center border-[#467E6D]"
          >
            I'm team Android
          </button>
          <button
            :disabled="disableButtons"
            v-on:click="voteFor('iPhone')"
            class="disabled:pointer-events-none disabled:opacity-50 flex-1 w-[155px] text-eggshell text-base border-2 rounded-full p-3 py-2.5 text-center border-[#798FA3]"
          >
            I'm team iPhone
          </button>
        </div>

        <p class="text-eggshell text-base mt-4 py-1" v-if="!loading">
          <template v-if="!disableButtons">Which team are you?</template>
          <template v-else
            >Thanks! Your vote for today has been recorded.</template
          >
        </p>
        <img
          class="w-full h-auto block mx-auto max-w-[284px] my-4"
          src="@/assets/team-squiggle.png"
        />

        <div class="relative max-w-[227px] mx-auto">
          <img src="@/assets/spread-bg.png" />
          <div class="inset-0 absolute p-4 text-eggshell">
            <p>Spread the word</p>

            <div class="flex items-center justify-center space-x-4 mt-2">
              <a
                href="mailto:?subject=Check this out! Nude is giving away 💰 £10,000 💰 to first time buyers!&body=Hey!%0D%0A%0D%0AI've%20just%20discovered%20this%20giveaway%20and%20you%20might%20like%20it%20too.%0D%0A%0D%0ANude%20is%20giving%20away%20%C2%A310%2C000%20to%20first%20time%20home%20buyers%20%F0%9F%8F%A1%20%0D%0A%0D%0AUse%20this%20link%20to%20enter%3A%20https%3A%2F%2Fgiveaway.getnude.com%2F"
                target="_blank"
              >
                <svg
                  width="32"
                  height="33"
                  viewBox="0 0 32 33"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M16 5.96916C14.4049 5.96994 12.8303 6.32844 11.3921 7.01828C9.95386 7.70813 8.68869 8.71174 7.68968 9.95523C6.69066 11.1987 5.98325 12.6504 5.61953 14.2035C5.2558 15.7566 5.24502 17.3714 5.58797 18.9292C5.93092 20.487 6.61888 21.948 7.6012 23.2048C8.58351 24.4615 9.83517 25.4819 11.264 26.1909C12.6929 26.8999 14.2626 27.2794 15.8575 27.3015C17.4524 27.3236 19.032 26.9876 20.48 26.3185C20.8009 26.1696 21.1678 26.1543 21.5 26.276C21.8322 26.3976 22.1024 26.6462 22.2513 26.9672C22.4002 27.2881 22.4155 27.655 22.2938 27.9872C22.1722 28.3194 21.9235 28.5896 21.6026 28.7385C19.8469 29.5517 17.9348 29.9717 16 29.9692C8.63596 29.9692 2.66663 23.9998 2.66663 16.6358C2.66663 9.27182 8.63596 3.30249 16 3.30249C23.364 3.30249 29.3333 9.27182 29.3333 16.6358V16.6612C29.2773 19.5812 28.3466 21.5478 26.9773 22.7678C25.6386 23.9598 24.0533 24.2852 22.9466 24.2852C21.3573 24.2852 19.9613 23.4585 19.1626 22.2132C16.3946 24.6598 12.4026 25.1985 9.93863 22.4598C7.37063 19.6065 8.08663 14.8425 10.8266 11.7985C13.4773 8.85316 18.2973 7.71582 21.064 11.1238C21.184 10.8014 21.424 10.5378 21.7339 10.3882C22.0437 10.2386 22.3994 10.2146 22.7266 10.3212C23.0537 10.4277 23.327 10.6567 23.4893 10.9601C23.6516 11.2635 23.6903 11.6179 23.5973 11.9492C22.808 14.7172 21.8773 17.4598 21.18 20.2518C21.2817 20.643 21.5104 20.9893 21.8301 21.2366C22.1498 21.4839 22.5424 21.6182 22.9466 21.6185C23.5866 21.6185 24.4773 21.4238 25.204 20.7772C25.8973 20.1598 26.62 18.9718 26.6666 16.6238C26.6634 13.7969 25.5382 11.0869 23.5382 9.08911C21.5381 7.09131 18.8269 5.96916 16 5.96916ZM19.1373 17.8545C19.2306 17.5345 19.4746 16.6798 19.76 15.6838C20.0706 14.5905 19.6666 13.5425 18.816 12.5958C17.5893 11.2345 14.96 11.1918 12.8093 13.5825C10.6453 15.9852 10.5666 19.1705 11.9213 20.6758C13.1466 22.0372 15.776 22.0798 17.928 19.6892C18.4253 19.1372 18.8933 18.5638 19.1373 17.8545Z"
                    fill="#F8D8AC"
                  />
                </svg>
              </a>
              <a
                href="whatsapp://send?text=Check this out! Nude is giving away 💰 £10,000 💰 to first time buyers! https://giveaway.getnude.com"
                target="_blank"
              >
                <svg
                  width="32"
                  height="33"
                  viewBox="0 0 32 33"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M4.66665 16.6359C4.66665 14.3943 5.33134 12.2032 6.57666 10.3394C7.82199 8.47565 9.59201 7.02302 11.6629 6.16523C13.7338 5.30744 16.0126 5.083 18.211 5.5203C20.4095 5.9576 22.4289 7.03699 24.0139 8.62199C25.5989 10.207 26.6783 12.2264 27.1156 14.4248C27.5529 16.6233 27.3284 18.902 26.4706 20.9729C25.6128 23.0438 24.1602 24.8139 22.2964 26.0592C20.4327 27.3045 18.2415 27.9692 16 27.9692C13.8558 27.973 11.755 27.3652 9.94399 26.2172C9.7829 26.1153 9.60183 26.0491 9.413 26.0231C9.22416 25.9971 9.03195 26.0119 8.84932 26.0665L5.00932 27.2119L6.45599 23.8292C6.54007 23.6323 6.57549 23.418 6.55925 23.2045C6.543 22.9909 6.47557 22.7845 6.36265 22.6025C5.25056 20.8113 4.66299 18.7442 4.66665 16.6359ZM16 2.63586C8.26799 2.63586 1.99999 8.90386 1.99999 16.6359C1.99999 19.0865 2.63065 21.3932 3.73999 23.3999L1.43999 28.7785C1.34044 29.0115 1.30934 29.2681 1.35033 29.5181C1.39132 29.7681 1.5027 30.0013 1.67142 30.1903C1.84015 30.3793 2.05924 30.5164 2.30303 30.5853C2.54683 30.6543 2.80523 30.6524 3.04799 30.5799L9.04799 28.7905C11.164 30.0031 13.5611 30.6394 16 30.6359C23.732 30.6359 30 24.3679 30 16.6359C30 8.90386 23.732 2.63586 16 2.63586ZM19.0573 19.5452L17.304 20.7799C16.3379 20.2241 15.4509 19.5411 14.6667 18.7492C13.8247 17.9084 13.0967 16.9607 12.5013 15.9305L13.6147 14.9852C13.8466 14.7884 14.0043 14.5181 14.0616 14.2193C14.1188 13.9205 14.0721 13.6112 13.9293 13.3425L12.5107 10.6759C12.4162 10.4988 12.2831 10.3453 12.1211 10.2268C11.9591 10.1083 11.7724 10.028 11.575 9.9917C11.3777 9.95543 11.1746 9.96418 10.9811 10.0173C10.7876 10.0704 10.6085 10.1666 10.4573 10.2985L10.036 10.6652C9.02399 11.5479 8.42532 12.9985 8.92132 14.4679C9.71933 16.792 11.0399 18.9021 12.7813 20.6359C15.1987 23.0532 17.6547 24.0052 19.092 24.3759C20.2493 24.6732 21.344 24.2745 22.116 23.6452L22.904 23.0025C23.0701 22.8671 23.2011 22.6935 23.2859 22.4966C23.3707 22.2998 23.4068 22.0853 23.3911 21.8715C23.3754 21.6578 23.3084 21.4509 23.1957 21.2685C23.0831 21.0861 22.9281 20.9336 22.744 20.8239L20.5067 19.4905C20.2854 19.3585 20.0307 19.2934 19.7732 19.3031C19.5158 19.3128 19.2667 19.3969 19.056 19.5452H19.0573Z"
                    fill="#F8D8AC"
                  />
                </svg>
              </a>

              <a
                href="https://twitter.com/intent/tweet?url=https%3A%2F%2Fgiveaway.getnude.com&text=Check this out! Nude is giving away 💰 £10,000 💰 to first time buyers!"
                target="_blank"
              >
                <svg
                  width="32"
                  height="33"
                  viewBox="0 0 32 33"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M19.7986 8.17981C19.1895 8.17956 18.5879 8.31455 18.0373 8.57503C17.4867 8.83552 17.0008 9.21501 16.6146 9.6861C16.2285 10.1572 15.9518 10.7081 15.8044 11.2992C15.6571 11.8902 15.6428 12.5066 15.7626 13.1038C15.8039 13.3107 15.7954 13.5245 15.738 13.7275C15.6805 13.9306 15.5757 14.1171 15.4321 14.2717C15.2886 14.4263 15.1104 14.5447 14.9121 14.617C14.7139 14.6894 14.5014 14.7136 14.292 14.6878C11.4249 14.3356 8.72226 13.1571 6.51329 11.2958C6.55463 12.0985 6.83329 12.9518 7.43729 13.8451L8.34262 15.1838L6.85596 15.8171L6.56929 15.9398C6.78263 16.1838 7.03863 16.4331 7.32529 16.6798C7.70851 17.0078 8.11392 17.309 8.53862 17.5811L8.55329 17.5905H8.55462L10.6186 18.8425L8.45862 19.9225C8.35196 19.9758 8.24529 20.0238 8.13863 20.0665C8.60308 20.4524 9.11474 20.7777 9.66129 21.0345L11.5146 21.9105L9.96263 23.2491C9.11596 23.9798 8.26396 24.5251 7.15863 24.8131C8.85387 25.7161 10.7459 26.1865 12.6666 26.1825C19.0746 26.1825 24.2346 21.0691 24.2346 14.8038V14.1105L24.8013 13.7118C25.6866 13.0905 26.312 12.2505 26.76 11.2891H23.88L23.5173 10.5291C23.1833 9.82604 22.6568 9.23208 21.9988 8.81623C21.3408 8.40038 20.5783 8.1797 19.8 8.17981H19.7986ZM4.75863 17.9131C4.63281 18.0572 4.53946 18.2267 4.48494 18.4101C4.43041 18.5934 4.41598 18.7864 4.44263 18.9758C4.59329 20.0438 5.23196 20.9638 5.93863 21.6665C6.13063 21.8571 6.33596 22.0398 6.55196 22.2145L6.45196 22.2411C5.81063 22.4011 4.94529 22.4345 3.50396 22.2945C3.23177 22.2678 2.95795 22.3254 2.71963 22.4596C2.48131 22.5938 2.29001 22.798 2.17168 23.0445C2.05334 23.2911 2.01369 23.5681 2.0581 23.838C2.10252 24.1078 2.22885 24.3575 2.41996 24.5531C3.75432 25.917 5.34835 26.9999 7.10799 27.7377C8.86763 28.4755 10.7572 28.8535 12.6653 28.8491C20.2826 28.8491 26.5306 22.9345 26.884 15.4705C28.604 14.0265 29.464 12.0705 29.928 10.2931C29.9795 10.0959 29.9852 9.88941 29.9445 9.68962C29.9038 9.48982 29.8178 9.30203 29.6931 9.14067C29.5685 8.97931 29.4085 8.84869 29.2254 8.75886C29.0424 8.66903 28.8412 8.62237 28.6373 8.62248H25.5C24.7326 7.43091 23.6111 6.50973 22.2931 5.98839C20.9752 5.46705 19.5271 5.37174 18.1522 5.71587C16.7773 6.06 15.5448 6.82626 14.6278 7.90698C13.7109 8.9877 13.1556 10.3286 13.04 11.7411C10.5822 11.1013 8.38307 9.71555 6.74529 7.77448C6.60025 7.60299 6.41424 7.47092 6.20452 7.39052C5.9948 7.31012 5.76816 7.28401 5.54566 7.3146C5.32315 7.34519 5.11197 7.43149 4.93172 7.5655C4.75148 7.69951 4.60801 7.87688 4.51462 8.08115C3.70662 9.84381 3.55196 11.8758 4.45329 13.9425L4.14129 14.0758C3.84272 14.203 3.60081 14.4348 3.4609 14.7276C3.32098 15.0205 3.29268 15.3543 3.38129 15.6665C3.62929 16.5358 4.18663 17.3038 4.75729 17.9131H4.75863Z"
                    fill="#F8D8AC"
                  />
                </svg>
              </a>
              <a
                href="https://www.facebook.com/sharer/sharer.php?u=https%3A%2F%2Fgiveaway.getnude.com"
                target="_blank"
              >
                <svg
                  width="32"
                  height="33"
                  viewBox="0 0 32 33"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M2.66663 8.63582C2.66663 7.22134 3.22853 5.86478 4.22872 4.86459C5.22892 3.86439 6.58547 3.30249 7.99996 3.30249H24C25.4144 3.30249 26.771 3.86439 27.7712 4.86459C28.7714 5.86478 29.3333 7.22134 29.3333 8.63582V24.6358C29.3333 26.0503 28.7714 27.4069 27.7712 28.4071C26.771 29.4073 25.4144 29.9692 24 29.9692H7.99996C6.58547 29.9692 5.22892 29.4073 4.22872 28.4071C3.22853 27.4069 2.66663 26.0503 2.66663 24.6358V8.63582ZM7.99996 5.96916C7.29272 5.96916 6.61444 6.25011 6.11434 6.75021C5.61424 7.2503 5.33329 7.92858 5.33329 8.63582V24.6358C5.33329 25.3431 5.61424 26.0213 6.11434 26.5214C6.61444 27.0215 7.29272 27.3025 7.99996 27.3025H16V17.9692H14.6666C14.313 17.9692 13.9739 17.8287 13.7238 17.5786C13.4738 17.3286 13.3333 16.9894 13.3333 16.6358C13.3333 16.2822 13.4738 15.9431 13.7238 15.693C13.9739 15.443 14.313 15.3025 14.6666 15.3025H16V13.3025C16 12.0648 16.4916 10.8778 17.3668 10.0027C18.242 9.12749 19.4289 8.63582 20.6666 8.63582H21.4666C21.8202 8.63582 22.1594 8.7763 22.4094 9.02635C22.6595 9.2764 22.8 9.61553 22.8 9.96916C22.8 10.3228 22.6595 10.6619 22.4094 10.912C22.1594 11.162 21.8202 11.3025 21.4666 11.3025H20.6666C20.404 11.3025 20.1439 11.3542 19.9013 11.4547C19.6586 11.5552 19.4381 11.7026 19.2524 11.8883C19.0667 12.074 18.9194 12.2945 18.8189 12.5371C18.7184 12.7798 18.6666 13.0398 18.6666 13.3025V15.3025H21.4666C21.8202 15.3025 22.1594 15.443 22.4094 15.693C22.6595 15.9431 22.8 16.2822 22.8 16.6358C22.8 16.9894 22.6595 17.3286 22.4094 17.5786C22.1594 17.8287 21.8202 17.9692 21.4666 17.9692H18.6666V27.3025H24C24.7072 27.3025 25.3855 27.0215 25.8856 26.5214C26.3857 26.0213 26.6666 25.3431 26.6666 24.6358V8.63582C26.6666 7.92858 26.3857 7.2503 25.8856 6.75021C25.3855 6.25011 24.7072 5.96916 24 5.96916H7.99996Z"
                    fill="#F8D8AC"
                  />
                </svg>
              </a>
            </div>
          </div>
        </div>
      </div>
      <!-- </a> -->
      <!-- <a
        class="py-10 block flex-1"
        href="https://apps.apple.com/app/apple-store/id1481067268?mt=8"
        target="_blank"
      >
        <img class="w-full h-auto block" src="@/assets/app.png" />

        <h3 class="text-eggshell font-header text-2xl pt-4">
          Discover the Nude app
        </h3>
        <p class="text-eggshell text-base py-1">
          Open an account in under 10 minutes and start working towards your
          home.
        </p>

        <span
          class="bg-red p-1 mt-2 inline-block px-3 font-bold text-textgrey rounded-full text-base"
        >
          Visit App Store
        </span>
      </a>
      <a
        class="py-10 block flex-1"
        href="https://blog.getnude.com/16-reasons-why-you-should-totally-use-nude-to-build-your-first-home-deposit/"
        target="_blank"
      >
        <img class="w-full h-auto block" src="@/assets/why.png" />

        <h3 class="text-eggshell font-header text-2xl pt-4">
          Read ‘Why Nude?’
        </h3>
        <p class="text-eggshell text-base py-1">
          16 reasons why you should totally use our app to build your deposit.
        </p>

        <span
          class="bg-red p-1 mt-2 inline-block px-3 font-bold text-textgrey rounded-full text-base"
        >
          Read it now
        </span>
      </a> -->
    </div>
  </div>
</template>

<script>
import { initializeApp } from "firebase/app";

import {
  getFirestore,
  doc,
  onSnapshot,
  getDoc,
  setDoc,
} from "firebase/firestore";

export default {
  name: "TeamVoting",
  data() {
    return {
      disableButtons: false,
      loading: true,
      counters: {
        android: "...",
        iPhone: "...",
      },
      firebaseApp: false,
    };
  },
  async mounted() {
    // TODO: Add SDKs for Firebase products that you want to use
    // https://firebase.google.com/docs/web/setup#available-libraries

    // Your web app's Firebase configuration
    const firebaseConfig = {
      apiKey: "AIzaSyDr1MzS9CRTe7AoosneodkSUxZc6E5oTRI",
      authDomain: "nude-giveaway.firebaseapp.com",
      projectId: "nude-giveaway",
      storageBucket: "nude-giveaway.appspot.com",
      messagingSenderId: "918361872202",
      appId: "1:918361872202:web:42ef73f8af7d52c20513b3",
    };

    // Initialize Firebase
    this.firebaseApp = initializeApp(firebaseConfig);

    if (new Date().toDateString() != localStorage.getItem("disabledToday")) {
      localStorage.removeItem("disabledToday");
    }
    if (localStorage.getItem("disabledToday")) {
      this.disableButtons = true;
    }

    const db = getFirestore(this.firebaseApp);
    onSnapshot(doc(db, "votescores", "android"), (doc) => {
      this.counters["android"] = doc.data().score;
    });
    onSnapshot(doc(db, "votescores", "iPhone"), (doc) => {
      this.counters["iPhone"] = doc.data().score;
    });

    await getDoc(doc(db, "votescores", "android"));
    this.loading = false;
  },
  methods: {
    async voteFor(payload) {
      this.counters[payload] = this.counters[payload] + 1;
      this.disableButtons = true;
      localStorage.setItem("disabledToday", new Date().toDateString());

      const db = getFirestore(this.firebaseApp);

      await setDoc(doc(db, "votescores", payload), {
        score: this.counters[payload],
      });
    },
  },
};
</script>
